import React from "react";
import "./App.css";
import { HashRouter as Router } from "react-router-dom";
import { Provider } from "jotai";
import { FontDeskProvider } from "./context/frontDeskContext";
import RootRouter from "./routes";
import { ToastContainer } from "react-toastify";
import { StoreProvider } from "./store/StoreContext";

function App() {
  return (
    <StoreProvider>
      <Provider>
        <Router>
          <FontDeskProvider>
            <RootRouter />

            <ToastContainer />
          </FontDeskProvider>
        </Router>
      </Provider>
    </StoreProvider>
  );
}

export default App;
